import { useContext, useEffect, useState } from "react";
import UserContext from "../../../contexts/ContextApi";
import { useParams } from "react-router-dom";
import { Button, Container, Destiny, Image, Packet } from "../../../GlobalStyle/PackCSS";
import checkPreto from "../../../Assets/CheckPreto.jpg";
import Header from "../Header";
import styled, { keyframes } from "styled-components";
import Slogan from "../Slogan";
import { useModal } from "../../../contexts/ModelContext";


export default function FilteredPacksComponent() {
    const { packs } = useContext(UserContext);
    const { continent } = useParams();
    const { openModal } = useModal();
    const [filteredPacks, setFilteredPacks] = useState([]);
    
    useEffect(() => {
        // Atualiza filteredPacks quando packs ou continent mudar
        const filtered = packs.filter(pack => pack.continent === continent);
        setFilteredPacks(filtered);
    }, [packs, continent]);
    const { setPackSelect, setPackId } = useContext(UserContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
    const [destiny, setDestiny] = useState('');
    const [isOrderSent, setIsOrderSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [number, setNumber] = useState("");
    const [origin, setOrigin] = useState("");
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [days, setDays] = useState(0);
    const [luggage, setLuggage] = useState(false);
    const [luggageCount, setLuggageCount] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
    const [isFlexible, setIsFlexible] = useState(true);
    const [departureDate, setDepartureDate] = useState('');
    const [returnDate, setReturnDate] = useState('');

    function reservarPack(id, destiny) {
        setPackSelect(destiny);
        setPackId(id);
        setIsModalOpen(true);
        setDestiny(destiny)
    }

    function closeModal() {
        setIsModalOpen(false);
    }

    function handleBackgroundClick(e) {
        if (isLoading) return; // não deixa fechar enquanto está enviando
        if (e.target.id === 'modal-background') {
            closeModal();
        }
    }

    // function orderPack(e) {
    //     e.preventDefault();
    //     let luggageStatus;
    //     if (luggage === false) {
    //         luggageStatus = "Não";
    //     } else {
    //         luggageStatus = "Sim";
    //     }

    //     let message =
    //         `    Informações de contato:
    // NOME: ${name}
    // PASSAGEIROS:
    // ADULTO: ${adults}
    // CRIANÇA: ${children}
    // ORIGEM: ${origin}
    // DESTINO: ${destiny}
    // MÊS: ${selectedMonth}
    // DIAS: ${days}
    // BAGAGEM DESPACHADA: ${luggageStatus}
    // QUANTAS: ${luggageCount}`;
    //     console.log(message);
    //     const encode = encodeURIComponent(message);
    //     window.open(`https://wa.me/5532984957373?text=${encode}`);
    //     setIsOrderSent(true);
    //     setIsModalOpen(false); // Fechar o modal de pedido
    //     setIsThankYouModalOpen(true); // Abrir o modal de agradecimento
    //     setName("");
    //     setOrigin("");
    //     setAdults(0);
    //     setChildren(0);
    //     setDays(0);
    //     setLuggage(false);
    //     setLuggageCount(0);
    //     setSelectedMonth('');
    //     setIsMonthDropdownOpen(false);
    // }

    async function orderPack(e) {
        e.preventDefault();
        console.log("ENTREI");
        if (isLoading) return;       // evita duplo clique
        setIsLoading(true);
        let luggageStatus = luggage ? "Sim" : "Não";

        const payload = {
            deal: {
                name: name,
                deal_custom_fields: [
                    { value: origin },
                    { value: destiny },
                    { value: days },
                    { value: selectedMonth },
                    { value: luggageCount },
                    { value: adults },
                    { value: children },
                    { value: departureDate },
                    { value: returnDate }
                ]
            },
            contacts: [
                {
                    name: name,
                    phones: [{ type: "cellphone", phone: number }]
                }
            ]
        };

        try {
            const response = await fetch("https://voecheapserverrdstation.onrender.com/api/create-deal", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            console.log("Negociação enviada com sucesso!");

            setIsModalOpen(false);
            setIsThankYouModalOpen(true);

            setName("");
            setNumber("");
            setOrigin("");
            setAdults(0);
            setChildren(0);
            setDays(0);
            setLuggage(false);
            setLuggageCount(0);
            setSelectedMonth("");
            setDepartureDate("");
            setReturnDate("");
            setIsFlexible(true);
        } catch (error) {
            console.error("Erro ao enviar negociação:", error);
        } finally {
            setIsLoading(false);
        }
    }

    function handleThankYouModalBackgroundClick(e) {
        if (e.target.id === 'modal-background-thank-you') {
            setIsThankYouModalOpen(false);
        }
    }

    const months = [
        'JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO',
        'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'
    ];

    function toggleMonthDropdown() {
        setIsMonthDropdownOpen(!isMonthDropdownOpen);
    }

    function selectMonth(month) {
        setSelectedMonth(month);
        setIsMonthDropdownOpen(true);
    }

    const handleSwapCities = () => {
        const temp = origin;
        setOrigin(destiny);
        setDestiny(temp);
    };

    const handleFlexibleChange = (val) => {
        setIsFlexible(val);

        if (val) {
            setDepartureDate('');
            setReturnDate('');
        } else {
            setSelectedMonth('');
            setIsMonthDropdownOpen(false);
        }
    };

    return (
        <Contained>
            <Header />
            <Slogan />
            <Title>{continent}</Title>
            <Contain>
                {filteredPacks.map((p, index) => (
                    <Packet key={index}>
                        <Image img={p.image}>
                            <div>{p.price}</div>
                        </Image>
                        <Destiny>
                            <div>{p.destiny}</div>
                        </Destiny>
                        <Container destiny={p.destiny}>
                            {p.destiny === 'PORTUGAL' ? (
                                <div>
                                    <img src="https://static.vecteezy.com/ti/vetor-gratis/p3/554188-de-asterisco-gratis-vetor.jpg" alt="asterisco" />
                                    <h1>{p.ticket}</h1>
                                </div>
                            ) : (
                                <div>
                                    <img src={checkPreto} alt="check" />
                                    <h1>{p.ticket}</h1>
                                </div>
                            )}
                            <div>
                                <img src={checkPreto} alt="check" />
                                <h1>{p.departureTax}</h1>
                            </div>
                            <div>
                                <img src={checkPreto} alt="check" />
                                <h1>{p.baggage}</h1>
                            </div>
                            <div>
                                <img src={checkPreto} alt="check" />
                                <h1>{p.support}</h1>
                            </div>
                            <div>
                                <img src={checkPreto} alt="check" />
                                <h1>{p.bilhete}</h1>
                            </div>
                        </Container>
                        <Button onClick={() => reservarPack(p.id, p.destiny)}><div>GARANTA SUA RESERVA</div></Button>
                    </Packet>
                ))}
            </Contain>
            {isModalOpen && (
                <ModalBackground id="modal-background" onClick={handleBackgroundClick}>
                    <Modal>
                        {/* <CloseButton onClick={closeModal}>X</CloseButton> */}
                        <Form onSubmit={orderPack}>
                            <h1>Olá, viajante!</h1>
                            <h2>Preencha os campos abaixo de acordo com suas preferências:</h2>

                            {/* Nome */}
                            <SubTitles>Seu nome:</SubTitles>
                            <label style={{ display: 'flex' }}>
                                <input
                                    style={{ borderRadius: '30px', border: 'none', width: '100%', marginBottom: '5px' }}
                                    type="text"
                                    name="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </label>

                            <SubTitles>Contato:</SubTitles>
                            <label style={{ display: 'flex' }}>
                                <input
                                    style={{ borderRadius: '30px', border: 'none', width: '50%' }}
                                    type="tel"
                                    name="number"
                                    value={number}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/\D/g, ''); // remove tudo que não for número

                                        // Aplica máscara conforme o tamanho
                                        // if (value.length <= 10) {
                                        //     value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
                                        // } else {
                                        //     value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
                                        // }

                                        setNumber(value);
                                    }}
                                    maxLength={15}
                                    required
                                    placeholder=""
                                />
                            </label>


                            {/* Passageiros */}
                            <div>
                                <label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <SubTitles>
                                            <span>Passageiros: </span>
                                        </SubTitles>
                                        <SubTitles style={{ marginLeft: '10px' }}>
                                            <span>Adultos:</span>
                                        </SubTitles>
                                        <Counter>
                                            <ButtonLeft
                                                style={{ textDecoration: 'none' }}
                                                type="button"
                                                onClick={() => setAdults(Math.max(0, adults - 1))}
                                            >
                                                -
                                            </ButtonLeft>
                                            <span>{adults}</span>
                                            <ButtonRight
                                                style={{ marginRight: '5px' }}
                                                type="button"
                                                onClick={() => setAdults(adults + 1)}
                                            >
                                                +
                                            </ButtonRight>
                                        </Counter>
                                        <SubTitles>Crianças:</SubTitles>
                                        <Counter>
                                            <ButtonLeft
                                                style={{ marginLeft: '5px' }}
                                                type="button"
                                                onClick={() => setChildren(Math.max(0, children - 1))}
                                            >
                                                -
                                            </ButtonLeft>
                                            <span>{children}</span>
                                            <ButtonRight
                                                style={{ marginRight: '5px' }}
                                                type="button"
                                                onClick={() => setChildren(children + 1)}
                                            >
                                                +
                                            </ButtonRight>
                                        </Counter>
                                    </div>
                                </label>
                            </div>

                            {/* Cidades */}
                            <Cities>
                                <label style={{ display: 'flex', flexDirection: 'column' }}>
                                    <SubTitlesCity>Cidade de origem:</SubTitlesCity>
                                    <City
                                        type="text"
                                        name="origin"
                                        value={origin}
                                        onChange={(e) => setOrigin(e.target.value)}
                                        required
                                    />
                                </label>

                                <div className="swap-container" onClick={handleSwapCities}>
                                    {/* Ícones para desktop e mobile */}
                                    <ion-icon name="swap-horizontal-outline" class="icon-desktop"></ion-icon>
                                    <ion-icon name="swap-vertical-outline" class="icon-mobile"></ion-icon>
                                </div>

                                <label style={{ display: 'flex', flexDirection: 'column' }}>
                                    <SubTitlesCity>Cidade de destino:</SubTitlesCity>
                                    <City type="text" name="destination" value={destiny} readOnly />
                                </label>
                            </Cities>

                            {/* Data flexível */}
                            <div>
                                <SubTitles>Data flexível?</SubTitles>
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '20px',
                                        alignItems: 'center',
                                        marginTop: '-5px'
                                    }}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <input
                                            style={{ width: '15px' }}
                                            type="radio"
                                            name="flexible"
                                            value="yes"
                                            checked={isFlexible}
                                            onChange={() => handleFlexibleChange(true)}
                                        />
                                        <h5>Sim</h5>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <input
                                            style={{ width: '15px' }}
                                            type="radio"
                                            name="flexible"
                                            value="no"
                                            checked={!isFlexible}
                                            onChange={() => handleFlexibleChange(false)}
                                        />
                                        <h5>Não</h5>
                                    </div>
                                </div>
                            </div>

                            {/* Condicional: flexível ou não */}
                            {isFlexible ? (
                                <>
                                    {/* Mês da viagem */}
                                    <div>
                                        <SubTitles> Mês da viagem: </SubTitles>
                                        <label
                                            style={{ display: 'flex', position: 'relative', width: '85px' }}
                                        >
                                            <input
                                                type="text"
                                                name="travelMonth"
                                                value={selectedMonth}
                                                onClick={toggleMonthDropdown}
                                                readOnly
                                                required
                                                placeholder=""
                                                style={{
                                                    cursor: 'pointer',
                                                    width: '85px',
                                                    border: 'none',
                                                    borderRadius: '30px',
                                                    display: 'flex',
                                                    paddingLeft: '5px',
                                                    height: '18px',
                                                    fontFamily: 'Montserrat',
                                                    fontWeight: 'bold',
                                                    fontSize: '10px',
                                                    backgroundImage:
                                                        'url(https://cdn-icons-png.flaticon.com/512/271/271210.png)',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundPosition: '70px center',
                                                    backgroundSize: '15px'
                                                }}
                                            />
                                            {isMonthDropdownOpen && (
                                                <MonthDropdown>
                                                    {months.map((month, index) => (
                                                        <MonthItem key={index} onClick={() => selectMonth(month)}>
                                                            {month}
                                                        </MonthItem>
                                                    ))}
                                                </MonthDropdown>
                                            )}
                                        </label>
                                    </div>

                                    {/* Dias de viagem */}
                                    <div>
                                        <label>
                                            <SubTitles>Quantos dias pretende ficar?</SubTitles>
                                            <Counter>
                                                <ButtonLeft
                                                    type="button"
                                                    onClick={() => setDays(Math.max(0, days - 1))}
                                                >
                                                    -
                                                </ButtonLeft>
                                                <span>{days}</span>
                                                <ButtonRight
                                                    type="button"
                                                    onClick={() => setDays(days + 1)}
                                                >
                                                    +
                                                </ButtonRight>
                                            </Counter>
                                        </label>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {/* Datas fixas */}
                                    <DatesRow>
                                        <div style={{ flex: 1 }}>
                                            <SubTitles>Data de ida:</SubTitles>
                                            <input
                                                type="date"
                                                value={departureDate}
                                                onChange={(e) => setDepartureDate(e.target.value)}
                                                required
                                                style={{
                                                    borderRadius: '30px',
                                                    border: 'none',
                                                    width: '100%',
                                                    fontFamily: 'Montserrat',
                                                    fontSize: '12px',
                                                    padding: '2px',
                                                }}
                                            />
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            <SubTitles>Data de volta:</SubTitles>
                                            <input
                                                type="date"
                                                value={returnDate}
                                                onChange={(e) => setReturnDate(e.target.value)}
                                                required
                                                style={{
                                                    borderRadius: '30px',
                                                    border: 'none',
                                                    width: '100%',
                                                    fontFamily: 'Montserrat',
                                                    fontSize: '12px',
                                                    padding: '2px',
                                                }}
                                            />
                                        </div>
                                    </DatesRow>

                                </>
                            )}

                            {/* Bagagem */}
                            <div>
                                <label>
                                    <SubTitles>Bagagem despachada (23kg)?</SubTitles>
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '20px',
                                            alignItems: 'center',
                                            marginTop: '-5px'
                                        }}
                                    >
                                        <div style={{ textAlign: 'center' }}>
                                            <input
                                                style={{ width: '15px' }}
                                                type="radio"
                                                name="luggage"
                                                value="yes"
                                                checked={luggage}
                                                onChange={() => setLuggage(true)}
                                            />
                                            <h5>Sim</h5>
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <input
                                                style={{ width: '15px' }}
                                                type="radio"
                                                name="luggage"
                                                value="no"
                                                checked={!luggage}
                                                onChange={() => setLuggage(false)}
                                            />
                                            <h5>Não</h5>
                                        </div>
                                    </div>
                                </label>

                                {luggage && (
                                    <label style={{ marginTop: '5px' }}>
                                        <SubTitles>Quantas:</SubTitles>
                                        <Counter>
                                            <ButtonLeft
                                                type="button"
                                                onClick={() => setLuggageCount(Math.max(0, luggageCount - 1))}
                                            >
                                                -
                                            </ButtonLeft>
                                            <span>{luggageCount}</span>
                                            <ButtonRight
                                                type="button"
                                                onClick={() => setLuggageCount(luggageCount + 1)}
                                            >
                                                +
                                            </ButtonRight>
                                        </Counter>
                                    </label>
                                )}
                            </div>

                            {/* Botão enviar */}
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <button
                                    style={{
                                        border: 'none',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        fontSize: '13px',
                                        width: '90px',
                                        height: '30px',
                                        borderRadius: '30px',
                                        textAlign: 'center',
                                        padding: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        opacity: isLoading ? 0.7 : 1,
                                        cursor: isLoading ? 'not-allowed' : 'pointer'
                                    }}
                                    type="submit"
                                    disabled={isLoading}
                                >
                                    {isLoading && <Spinner />}
                                    {isLoading ? 'ENVIANDO...' : 'ENVIAR'}
                                </button>
                            </div>
                        </Form>
                    </Modal>
                </ModalBackground>
            )}
            {isThankYouModalOpen && (
                <ModalThank id="modal-background-thank-you" onClick={handleThankYouModalBackgroundClick}>
                    <MiniModal>
                        <h1>OBRIGADO!</h1>
                        <h2>Nossa equipe já está buscando as <span>melhores opções</span> para você! :)</h2>
                        <h3>Aguarde que logo menos um de nossos agentes entrará em contato atráves do número fornecido.</h3>
                        <h4>Enquanto isso, vem acompanhar nossas redes: </h4>
                        <div>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Instagram_logo.png/768px-Instagram_logo.png" alt="insta" />
                            {/* <ion-icon name="logo-tiktok"></ion-icon> */}
                        </div>
                    </MiniModal>
                </ModalThank>
            )}
            {/* <Cotacao>
                <p>Não encontrou a passagem que queria?</p>
            </Cotacao>
            <Buttoned onClick={openModal}>Peça uma cotação personalizado</Buttoned > */}
        </Contained>
    );
};

const Contain = styled.div`
display: flex;
align-items: center;
flex-wrap: wrap;
justify-content: space-around;
width: 100%;
padding-bottom: 30px;
@media (max-width: 1200px) {
    width: 100%;
  }
`;

const Title = styled.h1`
  font-family: "Montserrat", sans-serif;
  margin-top: 50px;
font-size: 40px;
text-align: center;
`;

const Cotacao = styled.div`
width: 80%;
text-align: center;
margin-bottom: 10px;
padding: 5px;
border-radius: 20px;
font-weight: bold;
font-family: "Montserrat", sans-serif;
font-size: 15px;
background-color: #013881;
color: white;
@media(min-width:768px){
    width: 500px;
    font-size: 20px;
}
`;

const Buttoned = styled.button`
width: 50%;
margin-bottom: 30px;
padding: 5px;
border-radius: 15px;
font-weight: bold;
font-family: "Montserrat", sans-serif;
font-size: 10px;
border: none;
background-color: #798eb7;
color: white;
cursor: pointer;
transition: background-color 0.3s ease;
&:hover {
     background-color: rgba(33, 68, 136, 1);
}
@media(min-width:768px){
    width: 300px;
    font-size: 16px;
}
;`

const ModalBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`;

const ModalThank = styled.div`
 position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`;

const MiniModal = styled.div`
        background: #214488;
    padding: 20px;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    color: white;
    font-family: "Montserrat", sans-serif;
    div{
width: 100px;
height: 30px;
display: flex;
align-items: center;
justify-content: space-around;
img{
    width: 30px;
}
    }
    @media (min-width: 760px) {
    margin-top:-200px;
}
@media (min-width: 850px) and (min-height: 1200px) {
    top: -280px;
}
@media (min-width:900px) {
    width: 500px;
    height: 250px;
    top: 100px;
    text-align: center;
    h1{
        font-size: 50px;
        font-weight: bold;
    }
    h2{
        font-size: 25px;
        span{
            font-weight: bold;
        }
    }
    h4{
        font-size: 25px;
    }
}
`;

const Modal = styled.div`
  background: #214488;
  padding: 20px;
  border-radius: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 500px;

  /* Faz o modal crescer com o conteúdo */
  height: auto;
  min-height: 435px; /* altura mínima para manter o design */

  @media (min-width: 760px) {
    margin-top: -200px;
  }

  @media (max-width: 760px) {
    margin-top: 50px;
  }

  @media (min-width: 850px) and (min-height: 1200px) {
    top: -280px;
  }

  @media (min-width: 900px) {
    top: 100px;
  }
`;

// const CloseButton = styled.button`
//     position: absolute;
//     top: 10px;
//     right: 10px;
//     background: none;
//     border: none;
//     font-size: 1.5rem;
//     cursor: pointer;
// `;

const Counter = styled.div`
    display: flex;
    align-items: center;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 20px;
    }
    span {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        color: black;
    }
`;

const Form = styled.form`
color:white;
font-family: "Montserrat", sans-serif;
font-size: 10px;
h1{
    font-size:40px;
    font-weight: bold;
    margin-bottom:5px;
    @media(min-width:900px){
        font-size: 50px;
    }
}
h2{
    font-size: 15px;
    margin-bottom:10px;
    @media(min-width:900px){
     font-size:15px ;
    }

}
div{
    margin-top: 5px;
}
label{
    margin-top: 5px;
}
input{
    @media(min-width:900px){
        height: 25px;
    }
}
`;

const ButtonLeft = styled.button`
margin-left: 5px;
border: none;
border-right: 1px solid black;
width: 10px;
background-color: white;
`;

const ButtonRight = styled.button`
border: none;
border-left: 1px solid black;
width: 10px;
background-color: white;
`;

const MonthDropdown = styled.div`
    position: absolute;
    top: 15px;
    left: 0;
    background: white;
    border: 1px solid #ccc;
    width: 80px;
    color:black;
    z-index: 1000;
`;

const MonthItem = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
    cursor: pointer;
    &:hover {
        background-color: #f1f1f1;
    }
`;

const SubTitles = styled.h3`
 border-bottom: 2px solid white; 
 display: inline-block; 
 padding-bottom: 0px;
 font-size: 13px;
 @media(min-width:900px){
     font-size:15px;
     white-space: nowrap;
    }
`;

const City = styled.input`                                   
width: 200px;
border: none;
border-radius: 30px; 
margin-top: 5px;                                      
font-family: "Montserrat", sans-serif; 
font-weight: bold;
font-size: 13px;
@media(min-width:900px){
    width: 200px;
}
`;

const SubTitlesCity = styled.h3`
 border-bottom: 2px solid white; 
 display: inline-block; 
 padding-bottom: 0px; 
 width:125px;
 font-size: 13px;
 @media(min-width:900px){
     font-size:15px;
     white-space: nowrap;
     width:140px;
    }
`;

const Cities = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 12px;

  /* Ícone container */
  .swap-container {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* Ícones padrão */
  ion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.3s ease;
  }

  ion-icon:hover {
    transform: scale(1.2);
  }

  /* Esconde o ícone vertical no desktop */
  .icon-mobile {
    display: none;
  }

  /* DESKTOP */
  @media (min-width: 900px) {
    flex-direction: row;

    .icon-desktop {
      display: inline;
    }

    .icon-mobile {
      display: none;
    }
  }

  /* MOBILE */
  @media (max-width: 899px) {
    flex-direction: column;
    align-items: start;
    .icon-desktop {
      display: none;
    }

    .icon-mobile {
      display: inline;
      transform: rotate(0deg);
    }
  }
`;

const Contained = styled.div`
display: flex;
flex-direction: column;
align-items: center;
`;

const spin = keyframes`
  0% { 
    transform: rotate(0deg); 
  }
  100% { 
    transform: rotate(360deg); 
  }
`;

const Spinner = styled.div`
  border: 2px solid #f3f3f3;
  border-top: 2px solid #000000;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: ${spin} 0.7s linear infinite;
`;

const DatesRow = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
  }
`;
